import { PerformerRequest } from '@silbo/core';
import { formatRelative } from 'date-fns';
import { fr } from 'date-fns/locale';
import i18next from 'i18next';

export const formatRequestDate = (request: PerformerRequest): string => {
  const now = new Date();
  const options = { locale: fr };
  if (request.status === 'REQUESTED' && request.createdAt) {
    return i18next.t('requestDetails.requestReceivedAt', {
      date: formatRelative(request.createdAt, now, options),
      ns: 'bed-management',
    });
  } else if (request.fulfilledAt) {
    return formatRelative(request.fulfilledAt, now, options);
  }
  return '-';
};
